export default "__VITE_ASSET__387318dc__"